import SubscriptionSection from "../components/SubscriptionSection";
import Toaster from "../components/Toaster";

export default function Pricing() {
    return <>
        <Toaster />
        <div className="w-full max-w-screen-2xl mx-auto overflow-hidden flex-grow sm:pt-12">
            <section className="py-12 px-6 max-w-4xl mx-auto">
                <div className="max-w-6xl mx-auto text-center mb-6">
                    <h1 className="text-4xl font-bold mb-4 tracking-wide">Pricing</h1>
                    <p className="text-lg text-gray-300">Pick the plan that fits your needs. Change or cancel any time.</p>
                </div>
                <SubscriptionSection/>
            </section>
        </div>
    </>
}
